// 职责：创建一个router实例导出给main.js使用
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

// 公共路由
const Login = () => import(/* webpackChunkName: 'common' */ '@/views/common/login')
const home = () => import(/* webpackChunkName: 'common' */ '@/views/common/home')
const NotFound = () => import(/* webpackChunkName: 'common' */ '@/views/common/404')
const ForgetPass = () => import(/* webpackChunkName: 'common' */ '@/views/common/forgetPass')// 忘记密码
// 客服端
const CorderManage = () => import(/* webpackChunkName: 'customer' */ '@/views/soc-customer/orderManage')
const Cwaybill = () => import(/* webpackChunkName: 'customer' */ '@/views/soc-customer/orderManage/waybill')
const CgoodDetails = () => import(/* webpackChunkName: 'customer' */ '@/views/soc-customer/orderManage/goodDetails')
const CwayManage = () => import(/* webpackChunkName: 'customer' */ '@/views/soc-customer/wayManage')
const CafterSale = () => import(/* webpackChunkName: 'customer' */ '@/views/soc-customer/afterSale')
const captainAppoint = () => import(/* webpackChunkName: 'customer' */ '@/views/soc-customer/captain/appoint')// 车队长指派货运
const captainOrderManage = () => import(/* webpackChunkName: 'customer' */ '@/views/soc-customer/captain/orderManage')// 车队长订单管理
const captainDistribution = () => import(/* webpackChunkName: 'customer' */ '@/views/soc-customer/captain/orderManage/distribution')// 车队长分派
const captainGoodDetails = () => import(/* webpackChunkName: 'customer' */ '@/views/soc-customer/captain/orderManage/goodDetails')// 车队长订单详情
const captainWaybill = () => import(/* webpackChunkName: 'customer' */ '@/views/soc-customer/captain/orderManage/waybill')// 车队长运单
const captainWayManage = () => import(/* webpackChunkName: 'match' */ '@/views/soc-customer/captain/wayManage')// 车队长运单管理
const yunLiGuanLi = () => import(/* webpackChunkName: 'customer' */ '@/views/soc-customer/captain/yunLiGuanLi')// 运力管理
const cancellationRecord = () => import(/* webpackChunkName: 'customer' */ '@/views/soc-customer/cancellationRecord')// 撤单记录
const riskUnusual = () => import(/* webpackChunkName: 'customer' */ '@/views/soc-customer/risk/unusual')

// 货主端
const address = () => import(/* webpackChunkName: 'stock' */ '@/views/soc-stock/systemSetup/address')
const releaseGoods = () => import(/* webpackChunkName: 'stock' */ '@/views/soc-stock/releaseGoods')
const orderManage = () => import(/* webpackChunkName: 'stock' */ '@/views/soc-stock/orderManage')
const SafterSale = () => import(/* webpackChunkName: 'stock' */ '@/views/soc-stock/systemSetup/afterSale')
const SgoodDetails = () => import(/* webpackChunkName: 'stock' */ '@/views/soc-stock/orderManage/goodDetails')
const Swaybill = () => import(/* webpackChunkName: 'stock' */ '@/views/soc-stock/orderManage/waybill')
const orderManageEdit = () => import(/* webpackChunkName: 'stock' */ '@/views/soc-stock/orderManage/edit')
const SwayManage = () => import(/* webpackChunkName: 'stock' */ '@/views/soc-stock/wayManage')
const SrepairGoods = () => import(/* webpackChunkName: 'stock' */ '@/views/soc-stock/repairGoods')// 补单货源
const LongTermHY = () => import(/* webpackChunkName: 'stock' */ '@/views/soc-stock/LongTermHY') // 长期货源
const addCQHY = () => import(/* webpackChunkName: 'stock' */ '@/views/soc-stock/LongTermHY/addCQHY') // 长期货源-新建
const CQgoodDetails = () => import(/* webpackChunkName: 'stock' */ '@/views/soc-stock/LongTermHY/goodDetails') // 长期货源-详情

// 司机端2.0
const driverTow = () => import(/* webpackChunkName: 'driver' */ '@/views/vgs-driver2.0/driver')
const vehicleTow = () => import(/* webpackChunkName: 'driver' */ '@/views/vgs-driver2.0/vehicle')
const driverTowTenant = () => import(/* webpackChunkName: 'driver' */ '@/views/vgs-driver2.0/driver/tenant')
const vehicleTowTenant = () => import(/* webpackChunkName: 'driver' */ '@/views/vgs-driver2.0/vehicle/tenant')
const driverTowFleet = () => import(/* webpackChunkName: 'driver' */ '@/views/vgs-driver2.0/driver/fleet')
const vehicleTowFleet = () => import(/* webpackChunkName: 'driver' */ '@/views/vgs-driver2.0/vehicle/fleet')
const freightDriver = () => import(/* webpackChunkName: 'driver' */ '@/views/vgs-driver2.0/driver/freightDriver')

// crm改版
const NmenuManage = () => import(/* webpackChunkName: 'crm' */ '@/views/newCrm/menuManage')// 菜单管理
const NtenantManage = () => import(/* webpackChunkName: 'crm' */ '@/views/newCrm/tenantManage')// 租户管理
const tenantManageCustomer = () => import(/* webpackChunkName: 'crm' */ '@/views/newCrm/tenantManage/customer')// 租户客户
const NcustomerManage = () => import(/* webpackChunkName: 'crm' */ '@/views/newCrm/customerManage')// 客户管理
const customerMaintain = () => import(/* webpackChunkName: 'crm' */ '@/views/newCrm/customerManage/maintain')// 客户维护
const businessPlatform = () => import(/* webpackChunkName: 'crm' */ '@/views/newCrm/businessPlatform')// 业务管理平台
const modulePlatform = () => import(/* webpackChunkName: 'crm' */ '@/views/newCrm/modulePlatform')// 模块管理平台
const userManage = () => import(/* webpackChunkName: 'crm' */ '@/views/newCrm/userManage')// 用户管理通用
const organizational = () => import(/* webpackChunkName: 'crm' */ '@/views/newCrm/organizational')// 组织机构
const NrolePlatform = () => import(/* webpackChunkName: 'crm' */ '@/views/newCrm/rolePlatform')// 角色平台
const NroleTenant = () => import(/* webpackChunkName: 'crm' */ '@/views/newCrm/roleTenant')// 角色租户
const NpropertyConfig = () => import(/* webpackChunkName: 'crm' */ '@/views/newCrm/systemSet/propertyConfig')// 系统配置-属性配置
const appSettings = () => import(/* webpackChunkName: 'crm' */ '@/views/newCrm/systemSet/appSettings')
const operationLog = () => import(/* webpackChunkName: 'crm' */ '@/views/newCrm/operationLog')// 操作日志

// 平台- 合同管理
const carriage = () => import(/* webpackChunkName: 'consignment' */ '@/views/common-signature/contract/carriage')// 承运
const consignment = () => import(/* webpackChunkName: 'consignment' */ '@/views/common-signature/contract/consignment')// 托运
const contractPdf = () => import(/* webpackChunkName: 'consignment' */ '@/views/common-signature/contract/pdf')// -平台pdf
const daikaihetong = () => import(/* webpackChunkName: 'consignment' */ '@/views/common-signature/contract/daikaihetong')// 代开合同
const goodDetails = () => import(/* webpackChunkName: 'consignment' */ '@/views/common-signature/contract/goodDetails')// 平台端-货物详情

// 平台-用户钱包
const walletManagement = () => import(/* webpackChunkName: 'consignment' */ '@/views/common-signature/userWallet/walletManagement')// 提现管理
const recharge = () => import(/* webpackChunkName: 'consignment' */ '@/views/common-signature/userWallet/recharge') // 充值管理
const userBalance = () => import(/* webpackChunkName: 'consignment' */ '@/views/common-signature/userWallet/userBalance') // 用户余额

// 货主端-合同管理
const contractOwner = () => import(/* webpackChunkName: 'consignment' */ '@/views/soc-stock/contract/contractOwner')// 货主合同管理
const contractOwnerPdf = () => import(/* webpackChunkName: 'consignment' */ '@/views/soc-stock/contract/pdf')// 货主合同管理pdf
const detailsOwner = () => import(/* webpackChunkName: 'consignment' */ '@/views/soc-stock/contract/detailsOwner')// 合同管理-货物详情-货主端
// 托运端
const enterprise = () => import(/* webpackChunkName: 'consignment' */ '@/views/consignment/systemManagement/enterprise') // 系统管理-企业信息
const customerCheck = () => import(/* webpackChunkName: 'consignment' */ '@/views/consignment/registerAttestation/customerCheck')// 资质审核-客户审核
const vehicleCheck = () => import(/* webpackChunkName: 'consignment' */ '@/views/consignment/registerAttestation/vehicleCheck')// 资质审核-车辆审核
const driverCheck = () => import(/* webpackChunkName: 'consignment' */ '@/views/consignment/registerAttestation/driverCheck')// 资质审核-司机审核
const captainCheck = () => import(/* webpackChunkName: 'consignment' */ '@/views/consignment/registerAttestation/captainCheck')// 资质审核-车队长审核
const newCaptainCheck = () => import(/* webpackChunkName: 'consignment' */ '@/views/consignment/registerAttestation/captainCheck/indexCrm3')// 资质审核-车队长审核3.0
const statementCheck = () => import(/* webpackChunkName: 'consignment' */ '@/views/consignment/registerAttestation/statementCheck')// 资质审核-声明审核
const wayCheck = () => import(/* webpackChunkName: 'consignment' */ '@/views/consignment/registerAttestation/wayCheck')// 资质审核-运单审核
const enterpriseChedui = () => import(/* webpackChunkName: 'consignment' */ '@/views/consignment/systemManagement/enterpriseChedui') // 系统管理-企业信息（车队端）
// 货运端 财务管理
const Settlement = () => import(/* webpackChunkName: 'consignment' */ '@/views/consignment/payCustomer/settlement') // 货运端 财务管理-运费管理
const invoiceApply = () => import(/* webpackChunkName: 'consignment' */ '@/views/consignment/payCustomer/invoiceApply')// 货运端 财务管理-打包发票
const invoice = () => import(/* webpackChunkName: 'consignment' */ '@/views/consignment/payCustomer/invoice')// 货运端 财务管理-发票管理
const faPiaoShenQing = () => import(/* webpackChunkName: 'consignment' */ '@/views/consignment/payCustomer/faPiaoShenQing')// 货运端 财务管理-发票申请
const invoiceDetil = () => import(/* webpackChunkName: 'consignment' */ '@/views/consignment/payCustomer/invoiceDetil')// 货运端 财务管理-开票信息
const capital = () => import(/* webpackChunkName: 'consignment' */ '@/views/consignment/payCustomer/capital') // 货运端 财务管理-资金账户
const Recharge = () => import(/* webpackChunkName: 'consignment' */ '@/views/consignment/payCustomer/recharge')// 货运端 财务管理-资金账户-充值
const bankcard = () => import(/* webpackChunkName: 'consignment' */ '@/views/consignment/payCustomer/bankcard')// 货运端 财务管理-资金账户-银行卡
const withdrawal = () => import(/* webpackChunkName: 'consignment' */ '@/views/consignment/payCustomer/withdrawal')// 货运端 财务管理-资金账户-提现
// 平台端-发票管理
const payInvoice = () => import(/* webpackChunkName: 'platformEnd' */ '@/views/platformEnd/payInvoice')// 平台端-发票管理
const invoiceCheck = () => import(/* webpackChunkName: 'platformEnd' */ '@/views/platformEnd/invoiceCheck')// 平台端-发票审核
const Driver = () => import(/* webpackChunkName: 'platformEnd' */ '@/views/platformEnd/payPlatform/driver')// 货运端 财务管理-司机结算
const customer = () => import(/* webpackChunkName: 'platformEnd' */ '@/views/platformEnd/payPlatform/customer')// 货运端 财务管理-货主结算
const Capital = () => import(/* webpackChunkName: 'platformEnd' */ '@/views/platformEnd/payVehicle/capital')// 平台端-财务管理-资金账户
const payAccount = () => import(/* webpackChunkName: 'platformEnd' */ '@/views/platformEnd/payAccount')// 平台端-平台账户
const payAccountFreeze = () => import(/* webpackChunkName: 'platformEnd' */ '@/views/platformEnd/payAccount/freeze')// 平台端-平台账户-冻结记录
const payAccountJiaoYiMX = () => import(/* webpackChunkName: 'platformEnd' */ '@/views/platformEnd/payAccount/jiaoYiMX')// 平台端-平台账户-交易明细
const paymenWithholdingwaybillTax = () => import(/* webpackChunkName: 'platformEnd' */ '@/views/platformEnd/paymenWithholding/waybillTax')// 平台端-代缴代扣-运单税费
const paymenWithholdingtaxDeclaration = () => import(/* webpackChunkName: 'platformEnd' */ '@/views/platformEnd/paymenWithholding/taxDeclaration')// 平台端-代缴代扣-税务申报
const paymenWithholdingtaxSummary = () => import(/* webpackChunkName: 'platformEnd' */ '@/views/platformEnd/paymenWithholding/taxSummary')// 平台端-代缴代扣-个税汇总
const paymenWithholdingwaybillReport = () => import(/* webpackChunkName: 'platformEnd' */ '@/views/platformEnd/paymenWithholding/waybillReport')// 平台端-代缴代扣-运单上报
const paymenWithholdingIdentityRport = () => import(/* webpackChunkName: 'platformEnd' */ '@/views/platformEnd/paymenWithholding/IdentityRport')// 平台端-代缴代扣-身份上报
const payAccountBankcard = () => import(/* webpackChunkName: 'platformEnd' */ '@/views/platformEnd/payAccount/bankcard')// 平台端-平台账户-银行卡
const payAccountWithdrawal = () => import(/* webpackChunkName: 'platformEnd' */ '@/views/platformEnd/payAccount/withdrawal')// 平台端-平台账户-提现
const platformEndWithdrawal = () => import(/* webpackChunkName: 'platformEnd' */ '@/views/platformEnd/withdrawal')// 平台端-提现管理
const bankReceipt = () => import(/* webpackChunkName: 'platformEnd' */ '@/views/platformEnd/bankReceipt')// 平台端/货主端-银行回单
const zhangHuSet = () => import(/* webpackChunkName: 'platformEnd' */ '@/views/platformEnd/payAccount/zhangHuSet')// 平台端账户设置
const pingZhangJiLu = () => import(/* webpackChunkName: 'platformEnd' */ '@/views/platformEnd/payAccount/pingZhangJiLu')// 平台端平账记录
const transferRecords = () => import(/* webpackChunkName: 'platformEnd' */ '@/views/platformEnd/payAccount/transferRecords')// 平台端-划转记录
const CincomeDetails = () => import(/* webpackChunkName: 'platformEnd' */ '@/views/platformEnd/payPlatform/incomeDetails')// 平台端 -财务管理-收入明细
const oilgasCharge = () => import(/* webpackChunkName: 'platformEnd' */ '@/views/platformEnd/carService/oilgasCharge')// 平台 车后服务-油气充值记录
const oilgasConsume = () => import(/* webpackChunkName: 'platformEnd' */ '@/views/platformEnd/carService/oilgasConsume')// 平台 车后服务-油气消费记录
// 车队
const Withdrawal = () => import(/* webpackChunkName: 'platformEnd' */ '@/views/platformEnd/payVehicle/withdrawal')// 车队端-资金账户-提现
const Bankcard = () => import(/* webpackChunkName: 'platformEnd' */ '@/views/platformEnd/payVehicle/bankcard')// 车队端-资金账户-银行卡
// 车队长
const ziJin = () => import(/* webpackChunkName: 'platformEnd' */ '@/views/platformEnd/captainPay/ziJin')// 车队长-资金账户
const Bankcards = () => import(/* webpackChunkName: 'platformEnd' */ '@/views/platformEnd/captainPay/ziJin/bankcard')// 车队长-资金账户-银行卡
const Withdrawals = () => import(/* webpackChunkName: 'platformEnd' */ '@/views/platformEnd/captainPay/ziJin/withdrawal')// 车队长-资金账户-银行卡
const shouRu = () => import(/* webpackChunkName: 'platformEnd' */ '@/views/platformEnd/captainPay/shouRu')// 车队长-运费收入

// 报表统计
const reportStatisticScargoOwner = () => import(/* webpackChunkName:'platformEnd' */'@/views/data-center-server/reportStatistics/cargoOwner')// 货主活跃统计
const PlatformFreight = () => import(/* webpackChunkName:'platformEnd' */'@/views/data-center-server/reportStatistics/PlatformFreight')// 平台运价统计
const reportStatisticTransportation = () => import(/* webpackChunkName:'platformEnd' */'@/views/data-center-server/reportStatistics/transportation')// 运输报表统计
// import { import } from 'mathjs'
Vue.use(VueRouter)
const router = new VueRouter({
  // 路由规则
  routes: [
    { path: '/login', name: 'login', component: Login },
    { path: '/common/forgetPass', name: 'ForgetPass', component: ForgetPass },
    {
      path: '/',
      component: home,
      beforeEnter: (to, from, next) => {
        if (to.path == '/' && store.getIp()) {
          next(store.getIp())
        } else {
          next()
        }
      },
      children: [
        // 报表统计
        { path: '/reportStatistics/cargoOwner', name: 'reportStatisticScargoOwner', component: reportStatisticScargoOwner }, // 货物运营统计
        { path: '/reportStatistics/PlatformFreight', name: 'PlatformFreight', component: PlatformFreight }, // 平台运价统计
        { path: '/reportStatistics/transportation', name: 'reportStatisticTransportation', component: reportStatisticTransportation }, // 运输报表统计
        // 托运端
        { path: '/systemManagement/enterprise', name: 'enterprise', component: enterprise }, // 系统管理-企业信息
        { path: '/registerAttestation/customerCheck', name: 'customerCheck', component: customerCheck }, // 资质审核-客户审核
        { path: '/registerAttestation/vehicleCheck', name: 'vehicleCheck', component: vehicleCheck }, // 资质审核-车辆审核
        { path: '/registerAttestation/driverCheck', name: 'driverCheck', component: driverCheck }, // 资质审核-司机审核
        { path: '/registerAttestation/captainCheck', name: 'captainCheck', component: captainCheck }, // 资质审核-车队长审核
        { path: '/registerAttestation/newCaptainCheck', name: 'newCaptainCheck', component: newCaptainCheck }, // 资质审核-车队长审核3.0
        { path: '/registerAttestation/statementCheck', name: 'statementCheck', component: statementCheck }, // 资质审核-声明审核
        { path: '/registerAttestation/wayCheck', name: 'wayCheck', component: wayCheck }, // 资质审核-运单审核
        { path: '/systemManagement/enterpriseChedui', name: 'enterpriseChedui', component: enterpriseChedui }, // 系统管理-企业信息（车队端）
        // 货主端-财务管理
        { path: '/payCustomer/settlement', name: 'settlement', component: Settlement }, // 货主端-财务管理-运费管理
        { path: '/payCustomer/invoiceApply', name: 'invoiceApply', component: invoiceApply }, // 货主端-财务管理-发票服务
        { path: '/payCustomer/invoice', name: 'invoice', component: invoice }, // 货主端-财务管理-开票查询
        { path: '/payCustomer/invoiceDetil', name: 'invoiceDetil', component: invoiceDetil }, // 货主端-财务管理-开票信息
        { path: '/payCustomer/faPiaoShenQing', name: 'faPiaoShenQing', component: faPiaoShenQing }, // 货主端-财务管理-发票申请
        { path: '/payCustomer/capital', name: 'capital', component: capital }, // 货主端-财务管理-资金账户
        { path: '/payCustomer/recharge', name: 'recharge', component: Recharge }, // 货主端-财务管理-资金账户-充值
        { path: '/payCustomer/bankcard', name: 'bankcard', component: bankcard }, // 货主端-财务管理-资金账户-银行卡
        { path: '/payCustomer/withdrawal', name: 'withdrawal', component: withdrawal }, // 货主端-财务管理-资金账户-提现
        // 平台端
        { path: '/payInvoice', name: 'payInvoice', component: payInvoice }, // 平台端-发票管理
        { path: '/invoiceCheck', name: 'invoiceCheck', component: invoiceCheck }, // 平台端-发票审核
        { path: '/payPlatform/driver', name: 'driverS', component: Driver }, // 平台端-结算管理-司机结算
        { path: '/payPlatform/customer', name: 'customer', component: customer }, // 平台端-结算管理-货主结算
        { path: '/payVehicle/capital', name: 'capital', component: Capital }, // 平台端-财务管理-资金账户
        { path: '/payAccount', name: 'payAccount', component: payAccount }, // 平台端-平台账户
        { path: '/payAccount/freeze', name: 'payAccountFreeze', component: payAccountFreeze }, // 平台端-平台账户-冻结记录
        { path: '/payAccount/jiaoYiMX', name: 'payAccountJiaoYiMX', component: payAccountJiaoYiMX }, // 平台端-平台账户-交易明细
        { path: '/paymenWithholding/waybillTax', name: 'paymenWithholdingwaybillTax', component: paymenWithholdingwaybillTax }, // 平台端-代缴代扣-运费结算
        { path: '/paymenWithholding/taxDeclaration', name: 'paymenWithholdingtaxDeclaration', component: paymenWithholdingtaxDeclaration }, // 平台端-代缴代扣-税务申报
        { path: '/paymenWithholding/taxSummary', name: 'paymenWithholdingtaxSummary', component: paymenWithholdingtaxSummary }, // 平台端-代缴代扣-个税汇总
        { path: '/paymenWithholding/waybillReport', name: 'paymenWithholdingwaybillReport', component: paymenWithholdingwaybillReport }, // 平台端-代缴代扣-运单上报
        { path: '/paymenWithholding/IdentityRport', name: 'paymenWithholdingIdentityRport', component: paymenWithholdingIdentityRport }, // 平台端-代缴代扣-身份上报
        { path: '/payAccount/bankcard', name: 'payAccountBankcard', component: payAccountBankcard }, // 平台端-平台账户-银行卡
        { path: '/payAccount/withdrawal', name: 'payAccountWithdrawal', component: payAccountWithdrawal }, // 平台端-平台账户-提现
        { path: '/platformEnd/withdrawal', name: 'platformEndWithdrawal', component: platformEndWithdrawal }, // 平台端-提现管理
        { path: '/bankReceipt', name: 'bankReceipt', component: bankReceipt }, // 平台端/货主端-银行回单
        { path: '/payAccount/zhangHuSet', name: 'zhangHuSet', component: zhangHuSet }, // 平台端-账户设置
        { path: '/payAccount/pingZhangJiLu', name: 'pingZhangJiLu', component: pingZhangJiLu }, // 平台端-平账记录
        { path: '/payAccount/transferRecords', name: 'transferRecords', component: transferRecords }, // 平台端-划转记录
        { path: '/payPlatform/incomeDetails', name: 'CincomeDetails ', component: CincomeDetails }, // 平台端-财务管理-收入明细
        { path: '/oilgasCharge', name: 'oilgasCharge', component: oilgasCharge }, // 平台端-车后服务-油气充值记录
        { path: '/oilgasConsume', name: 'oilgasConsume', component: oilgasConsume }, // 平台端-车后服务-油气消费记录
        // 车队
        { path: '/payVehicle/bankcard', name: 'bankcard', component: Bankcard }, // 车队端-财务管理-资金账户-银行卡
        { path: '/payVehicle/withdrawal', name: 'withdrawal', component: Withdrawal }, // 车队端-财务管理-资金账户-提现
        // 车队长
        { path: '/captainPay/ziJin', name: 'ziJin', component: ziJin }, // 车队长-财务管理-资金账户
        { path: '/captainPay/ziJin/bankcard', name: 'Bankcards', component: Bankcards }, // 车队长-财务管理-资金账户
        { path: '/captainPay/ziJin/withdrawal', name: 'Withdrawals', component: Withdrawals }, // 车队长-财务管理-资金账户
        { path: '/captainPay/shouRu', name: 'shouRu', component: shouRu }, // 车队长-收入
        // 客服端
        {
          path: '/CorderManage',
          name: 'CorderManage',
          component: CorderManage,
          meta: {
            keepAlive: true // 需要被缓存
          }
        },
        {
          path: '/CorderManage/CgoodDetails',
          name: 'CgoodDetails',
          component: CgoodDetails
        },
        {
          path: '/CorderManage/Cwaybill',
          name: 'Cwaybill',
          component: Cwaybill
        },
        {
          path: '/CwayManage',
          name: 'CwayManage',
          component: CwayManage
        },
        { path: '/CafterSale', name: 'CafterSale', component: CafterSale },
        { path: '/captainAppoint', name: 'captainAppoint', component: captainAppoint }, // 车队长指派货运
        { path: '/captainOrderManage', name: 'captainOrderManage', component: captainOrderManage, meta: { keepAlive: true } }, // 车队长订单管理
        { path: '/captainDistribution', name: 'captainDistribution', component: captainDistribution }, // 车队长分派
        { path: '/captainGoodDetails', name: 'captainGoodDetails', component: captainGoodDetails }, // 车队长订单详情
        { path: '/captainWaybill', name: 'captainWaybill', component: captainWaybill }, // 车队长运单
        { path: '/captainWayManage', name: 'captainWayManage', component: captainWayManage }, // 车队长运单管理
        { path: '/yunLiGuanLi', name: 'yunLiGuanLi', component: yunLiGuanLi }, // 运力管理
        { path: '/cancellationRecord', name: 'cancellationRecord', component: cancellationRecord }, // 撤单记录
        { path: '/unusual', name: 'riskUnusual', component: riskUnusual }, // 异常风险
        {
          path: '/systemSetup/address',
          name: 'address',
          component: address
        },
        {
          path: '/releaseGoods',
          name: 'releaseGoods',
          component: releaseGoods
        },
        {
          path: '/orderManage',
          name: 'orderManage',
          component: orderManage,
          meta: {
            keepAlive: true // 需要被缓存
          }
        },
        {
          path: '/systemSetup/afterSale',
          name: 'SafterSale',
          component: SafterSale
        },
        { path: '/orderManage/goodDetails', name: 'SgoodDetails', component: SgoodDetails },
        { path: '/orderManage/waybill', name: 'Swaybill', component: Swaybill },
        { path: '/orderManage/edit', name: 'orderManageEdit', component: orderManageEdit },
        { path: '/SwayManage', name: 'SwayManage', component: SwayManage },
        { path: '/SrepairGoods', name: 'SrepairGoods', component: SrepairGoods },
        { path: '/LongTermHY', name: 'LongTermHY', component: LongTermHY }, // 长期货源
        { path: '/addCQHY', name: 'addCQHY', component: addCQHY }, // 长期货源-新建
        { path: '/CQgoodDetails', name: 'CQgoodDetails', component: CQgoodDetails }, // 长期货源-详情
        // 合同管理
        {
          path: '/carriage',
          name: 'Carriage',
          component: carriage
        },
        {
          path: '/consignment',
          name: 'Consignment',
          component: consignment
        },
        {
          path: '/contractPdf',
          name: 'ContractPdf',
          component: contractPdf
        },
        {
          path: '/daikaihetong',
          name: 'daikaihetong',
          component: daikaihetong
        },
        // 平台-提现管理
        {
          path: '/userWallet/walletManagement',
          name: 'WalletManagement',
          component: walletManagement
        }, {
          path: '/userWallet/recharge',
          name: 'Recharge',
          component: recharge
        }, {
          path: '/userWallet/userBalance',
          name: 'userBalance',
          component: userBalance
        },
        // 货主端-合同管理
        {
          path: '/contractOwner',
          name: 'ContractOwner',
          component: contractOwner
        },
        {
          path: '/contractOwnerPdf',
          name: 'ContractOwnerPdf',
          component: contractOwnerPdf
        },

        {
          path: '/goodDetails',
          name: 'GoodDetails',
          component: goodDetails
        },
        {
          path: '/detailsOwner',
          name: 'DetailsOwner',
          component: detailsOwner
        },

        // 司机端2.0
        { path: '/driverTow', name: 'driverTow', component: driverTow },
        { path: '/vehicleTow', name: 'vehicleTow', component: vehicleTow },
        { path: '/driverTowTenant', name: 'driverTowTenant', component: driverTowTenant },
        { path: '/vehicleTowTenant', name: 'vehicleTowTenant', component: vehicleTowTenant },
        { path: '/driverTowFleet', name: 'driverTowFleet', component: driverTowFleet },
        { path: '/vehicleTowFleet', name: 'vehicleTowFleet', component: vehicleTowFleet },
        { path: '/freightDriver', name: 'freightDriver', component: freightDriver },
        // crm改版
        { path: '/NmenuManage', name: 'NmenuManage', component: NmenuManage }, // 菜单管理
        { path: '/NtenantManage', name: 'NtenantManage', component: NtenantManage }, // 租户管理
        { path: '/NtenantManage/customer', name: 'tenantManageCustomer', component: tenantManageCustomer }, // 租户客户
        { path: '/NcustomerManage', name: 'NcustomerManage', component: NcustomerManage }, // 客户管理
        { path: '/NcustomerManage/maintain', name: 'customerMaintain', component: customerMaintain }, // 客户维护
        { path: '/businessPlatform', name: 'businessPlatform', component: businessPlatform }, // 业务管理平台
        { path: '/modulePlatform', name: 'modulePlatform', component: modulePlatform }, // 模块管理平台
        { path: '/userManage', name: 'userManage', component: userManage }, // 用户管理通用
        { path: '/organizational', name: 'organizational', component: organizational }, // 组织机构
        { path: '/NrolePlatform', name: 'NrolePlatform', component: NrolePlatform }, // 角色平台
        { path: '/NroleTenant', name: 'NroleTenant', component: NroleTenant }, // 租户角色
        { path: '/systemSet/propertyConfig', name: 'NpropertyConfig', component: NpropertyConfig }, // 租户角色
        { path: '/systemSet/appSettings', name: 'appSettings', component: appSettings },
        { path: '/operationLog', name: 'operationLog', component: operationLog } // 操作日志
      ]
    },
    // 404 处理  通配
    {
      path: '*',
      name: '404',
      component: NotFound
    }
  ]
})
// 前置守卫
router.beforeEach((to, from, next) => {
  const user = store.getUser()
  const url = store.getIp()
  let openFlag = to.path.indexOf('NoLogin') == -1
  if (to.path === '/login' && user.access_token) {
    next(url)
  } else if (openFlag && to.path !== '/login' && to.path !== '/home' && to.path != '/common/register' && to.path != '/common/authentication' && to.path != '/common/forgetPass' && !user.access_token) {
    store.delUser()
    localStorage.clear()
    sessionStorage.clear()
    next('/login')
  } else {
    next()
  }
})
/* 路由异常错误处理，尝试解析一个异步组件时发生错误，重新渲染目标页面 */
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern) || error.message.match('chunk')
  if (isChunkLoadFailed) {
    location.reload()
  }
})
export default router
